import React, { useState } from "react";
import { IconClose } from "../../../components/Ui/Icon";
import LoadingOverlay from "../../../components/Ui/LoadingOverlay";
import { adminCreateProfile } from "../../../store/user-action";
import { toast } from "react-toastify";
import { commonIcon } from "../../../asset";

import PhoneInput from "react-phone-input-2";
import {
  generateStrongPassword,
  formatDate,
} from "../../../utils/utils";
import { ROLE, USER_ROLES_CREATE_FORM } from "../../../constants/index";

const CreatePlan = ({ togglePopup, onSubmited }) => {
  const [loading, setLoading] = useState(false);

  const [isEyeOpen, setEyeOpen] = useState(false);
  const [formValue, setFormValue] = useState({
    name: "",
    email: "",
    phone: undefined,
    password: "",
    role: "gold",
    status: "active",
    type: "normal",
    isVerifyEmail: true,
    maxRateLimit: 0,
    currentLimit: 0,
    lang: "English",
    chatType: "private",
    nickname: "",
    biography: "",
    freeLimitEndDate: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setFormValue((preValue) => ({
      ...preValue,
      [`${name}`]: value,
    }));
  };

  const handlePhoneChange = (value) => {
    setFormValue((preValue) => ({
      ...preValue,
      phone: value,
    }));
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    console.log(formValue);
    const callAPI = async () => {
      setLoading(true);
      try {
        await adminCreateProfile(formValue);
        setTimeout(() => {
          setLoading(false);
        });
        toast.success("Successfully");
        togglePopup();
        onSubmited();
      } catch (error) {
        toast.error(error?.response?.data?.message);
        setLoading(false);
      }
    };
    callAPI();
  };

  const generatePassword = () => {
    const pwd = generateStrongPassword(8);
    console.log(pwd);
    setFormValue((preValue) => ({
      ...preValue,
      password: pwd,
    }));
  };

  return (
    <div>
      {loading && <LoadingOverlay />}
      <div className="modal flex overflow-y-auto overflow-x-hidden fixed inset-0 bg-gray-700 bg-opacity-75 z-[6] justify-center items-center w-full max-h-full">
        <div
          className="relative p-4 w-full max-w-4xl max-h-full"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
            <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
              <h3 className="text-xl font-semibold text-black dark:text-white">
                Create User
              </h3>
              <button
                type="button"
                className="z-[7] text-gray-400 bg-transparent hover:bg-gray-200 hover:text-black rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                onClick={togglePopup}
              >
                <IconClose />
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            <div className="p-4 md:p-5 space-y-4">
              <div className="flex flex-col md:flex-row w-full">
                <div className="w-full p-4 overflow-x-auto shadow-md shadow-slate-300">
                  <form
                    onSubmit={(e) => onSubmitHandler(e)}
                    className="grid gap-4 sm:grid-cols-2 sm:gap-6 [&_input]:outline-none [&_textarea]:outline-none"
                  >
                    <div className="sm:col-span-1">
                      <label
                        htmlFor="name"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formValue.name}
                        onChange={handleChange}
                        placeholder="Full name"
                        required
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>
                    <div className="sm:col-span-1">
                      <label
                        htmlFor="phone"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Phone
                      </label>
                      <PhoneInput
                        inputProps={{
                          name: "phone",
                          autoFocus: false,
                        }}
                        name="phone"
                        value={formValue.phone}
                        containerClass="w-full"
                        buttonClass="border !border-gray-200 !rounded-l-md !z-50"
                        inputClass="w-full !h-[42px] !rounded-md border !border-gray-200 focus:outline-none focus:ring-1 !focus:border-blue-900 peer"
                        country={"us"}
                        onChange={handlePhoneChange}
                      />
                      {/* <input
                        type="text"
                        name="phone"
                        value={formValue.phone}
                        onChange={handleChange}
                        placeholder="Phone number"
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      /> */}
                    </div>
                    <div className="sm:col-span-1">
                      <label
                        htmlFor="email"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Email
                      </label>
                      <input
                        type="text"
                        name="email"
                        value={formValue.email}
                        onChange={handleChange}
                        placeholder="Email address"
                        required
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>

                    <div className="sm:col-span-1">
                      <label
                        htmlFor="role"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        User Type
                      </label>
                      <select
                        className={`${
                          formValue.role === ROLE.GOLD
                            ? "border-yellow-600"
                            : ""
                        } shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}
                        name="role"
                        defaultValue={formValue.role}
                        onChange={(e) =>
                          setFormValue((preValue) => ({
                            ...preValue,
                            role: e.target.value,
                          }))
                        }
                      >
                        {USER_ROLES_CREATE_FORM.map((u) => (
                          <option value={u.id} key={u.id}>
                            {u.value}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="sm:col-span-2">
                      {" "}
                      <label
                        htmlFor="password"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Password
                      </label>
                      <div className="relative w-full">
                        <input
                          type={isEyeOpen ? "text" : "password"}
                          name="password"
                          value={formValue.password}
                          onChange={handleChange}
                          required
                          className="block outline-none p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-lg border focus:ring-blue-500 focus:border-blue-500"
                          placeholder="Password..."
                        />
                        <button
                          type="button"
                          onClick={() => setEyeOpen(!isEyeOpen)}
                          className="absolute top-0 end-20 p-2.5 text-sm font-medium h-full"
                        >
                          {isEyeOpen ? (
                            <img
                              src={commonIcon.isOpenEye}
                              className="hover:scale-105"
                              alt=""
                            />
                          ) : (
                            <img
                              src={commonIcon.isCloseEye}
                              className="hover:scale-95"
                              alt=""
                            />
                          )}
                        </button>

                        <button
                          type="button"
                          onClick={generatePassword}
                          className="absolute top-0 end-0 p-2.5 text-sm font-medium h-full text-white bg-slate-400 rounded-e-lg border border-slate-300 hover:bg-slate-500 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        >
                          <span>Generate</span>
                        </button>
                      </div>
                    </div>
                    {/* <div className="sm:col-span-2">
                      <label
                        htmlFor="password"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Password
                      </label>
                      <input
                        type="password"
                        name="password"
                        value={formValue.password}
                        onChange={handleChange}
                        placeholder="Password"
                        required
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div> */}

                    <div className="sm:col-span-1">
                      <label
                        htmlFor="maxRateLimit"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Limit
                      </label>
                      <input
                        type="number"
                        name="maxRateLimit"
                        value={formValue.maxRateLimit}
                        onChange={handleChange}
                        placeholder="Limit"
                        required={formValue.role === ROLE.USER ? true : false}
                        min={formValue.role === ROLE.USER ? 1 : 0}
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>
                    <div className="sm:col-span-1">
                      <label
                        htmlFor="freeLimitEndDate"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Limit End Time
                      </label>
                      <input
                        type="date"
                        name="freeLimitEndDate"
                        value={formValue.limitEndDate}
                        onChange={handleChange}
                        required={formValue.role === ROLE.USER ? true : false}
                        min={formValue.role === ROLE.USER ? formatDate() : ""}
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>
                    <div className="flex justify-center sm:col-span-2">
                      <button
                        disabled={loading}
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePlan;
